export default __webpack_public_path__ + "static/media/push46.1dce6cb0.gif";